module.exports = __webpack_public_path__ + "img/icon-camera.c12306b8.svg";